<ng-container *ngFor="let table of dataIndicators; let i = index; let lastRow = last">
    <div [ngClass]="{ 'mb-3': lastRow }" class="tablero-row-container">
        <div class="minculturas">
            <div class="tablero-informativo px-3 p-formgrid grid" #rowBoard>
                <ng-container *ngFor="let dataIndicator of table; let i = index; let lastColumRow = last">
                    <div [ngClass]="[
                            dataIndicator.col || 'col-12 py-2',
                            (lastRow && lastColumRow) ? 'last-item' : ''
                        ]">
                        <ng-container *ngIf="dataIndicator.type === 'text'">
                            <p [ngClass]="{
                                'naranja': dataIndicator.status === 1,
                                'amarillo-mostaza': dataIndicator.status === 2,
                                'verde': dataIndicator.status === 3,
                                'rojo-fucsia': dataIndicator.status === 4,
                                'msg-alert': dataIndicator.status
                            }">
                                <b>{{ dataIndicator.title }}:</b>{{ dataIndicator.description }}
                            </p>
                        </ng-container>

                        <ng-container *ngIf="dataIndicator.type === 'text_long'">
                            <p>
                                <b>{{ dataIndicator.title }}:</b>{{ dataIndicator.description }}
                            </p>
                        </ng-container>

                        <ng-container *ngIf="dataIndicator.type === 'date'">
                            <b>{{ dataIndicator.title }}:</b>{{ dataIndicator.description | date:'dd/MM/YYYY' }}
                        </ng-container>

                        <ng-container *ngIf="dataIndicator.type === 'numeric'">
                            <p>
                                <b>{{ dataIndicator.title }}:</b>{{ formatNumber(dataIndicator.description) }}
                            </p>
                        </ng-container>

                        <ng-container *ngIf="dataIndicator.type === 'money'">
                            <span>
                                <p>
                                    <b>{{ dataIndicator.title }}:</b> $ {{ dataIndicator.description | number:'1.2-2' }}
                                </p>
                            </span>
                        </ng-container>

                        <ng-container *ngIf="dataIndicator.type === 'percentage'">
                            <p>
                                <b>{{ dataIndicator.title }}:</b> {{ formatNumber(dataIndicator.description) }} %
                            </p>
                        </ng-container>
                    </div>
                </ng-container>
            </div>
        </div>
    </div>
</ng-container>